import axios from 'axios';
import apiConfig from '../api.config';

export default function pmsConfigDynamicFormByHotelId({ hotelId }) {
  const {
    host,
    URIs: { pmsConfigDynamicFormByHotelId },
  } = apiConfig;

  const uri = `${host}${pmsConfigDynamicFormByHotelId.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
